import React, { Fragment, useEffect, useContext, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import ProductCard2 from "../ProductCard/ProductCard2";
import "../../App.css";
import "../ProductList/ProductList.css";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./categories.css";
import { common_product_widget } from "../../Actions/Widgets";
import { refreshToken } from "../../Actions/Auth";
import InfiniteScroll from "react-infinite-scroll-component";
import { usersData } from "../../App";
import ErrorModal from "../Modals/ErrorModal";
import NoData from "../../Images/png/no_data.png";

const SchemesByDiscount = () => {
  let navigate = useNavigate();
  let location = useLocation();

  const [allProductList, setAllProductList] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [dataLength, setDataLength] = useState(0);
  const { setShowMaintenance } = useContext(usersData);
  const [errorModal, setErrorModal] = useState(false);
  const [homeShimmer, setHomeShimmer] = useState(false);
  const getAllProducts = (locationChange) => {
    let disc = location.pathname.split("/")[3];
    let fromDisc;
    let toDisc;
    if (disc === "all") {
      fromDisc = "0";
      toDisc = "100";
    } else {
      fromDisc = disc.split("-")[0];
      toDisc = disc.split("-")[1];
    }
    page === 0 && setHomeShimmer(true);
    locationChange && setHomeShimmer(true);
    const params = {
      fromDiscount: fromDisc,
      toDiscount: toDisc,
      page: page,
    };
    if (locationChange) {
      setPage(0);
      params.page = 0;
    }

    let api = common_product_widget("home/v2/getMedicinesByDiscount", params);
    api
      .then((res) => {
        let obj =
          allProductList && allProductList.medicinesResponsesList
            ? allProductList
            : { medicinesResponsesList: [] };
        if (locationChange) {
          obj = { medicinesResponsesList: [] };
        }
        if (res.data.data.medicinesResponsesList.length > 0) {
          obj.medicinesResponsesList.push(
            ...res.data.data.medicinesResponsesList
          );
          setDataLength(obj.medicinesResponsesList.length);
        }
        setAllProductList(obj);

        if (
          res.data.data.size > 0 &&
          obj.medicinesResponsesList.length < 10
        ) {
          if (params.page === 0) {
            fetchMoreData(true);
          } else {
            fetchMoreData(false);
          }
        } else if (
          res.data.data.size > 0 &&
          res.data.data.medicinesResponsesList.length === 0
        ) {
          if (params.page === 0) {
            fetchMoreData(true);
          } else {
            fetchMoreData(false);
          }
        }

        if (res.data.data.size === 0) {
          setHasMore(false);
        }
      
        setHomeShimmer(false);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          refreshToken().then((res) => {
            getAllProducts();
          });
        } else if (
          error?.response?.status === 502 ||
          error?.response?.status === 503 ||
          error?.response?.status === 504
        ) {
          setShowMaintenance({ status: true, apiData: error?.response });
        } else if (error?.response?.status === 500) {
          setErrorModal({
            show: true,
            apiData: error?.response,
            content: "Oops something went wrong !",
            tryAgain: function () {
              getAllProducts();
            },
          });
        } else {
          setErrorModal({
            show: true,
            apiData: error?.response,
            content: error?.response?.data?.error?.error
              ? error.response.data.error.error
              : "Something went wrong!",
            tryAgain: function () {
              getAllProducts();
            },
          });
        }
      });
  };

  const fetchMoreData = (status) => {
    let currScreen = window.location.href.split("/").pop();
    let funcScreen = location.pathname.split("/").pop();
    if(currScreen === funcScreen){
      if(status){
        setPage(1)
      }else{
        setPage(+page + 1);
      }
      
    }
  };
  useEffect(() => {
    let userData = localStorage.getItem("userData");

    if (userData) {
     page !== 0 &&  getAllProducts();
    } else {
      navigate("/home");
    }
  }, [page]);

  useEffect(() => {
    localStorage.setItem("currentScreen", "regular_scheme_screen");
    setAllProductList();
    setHasMore(true);
    setPage(0);
    getAllProducts(true);
  }, [location]);

  return (
    <Fragment>
      <ErrorModal
        show={errorModal.show}
        content={errorModal.content}
        apiData={errorModal?.apiData}
        onHide={() => {
          setErrorModal({ show: false, content: "" });
        }}
        tryAgain={() => {
          errorModal?.tryAgain();
          setErrorModal({ show: false, content: "" });
        }}
      />
      <Container fluid className="productList">
        <Container fluid className="productListHeader font_ubuntu display_flex">
          <HiOutlineArrowNarrowLeft
            className="cursor_pointer goBack"
            style={{ marginLeft: "-10px" }}
            onClick={() => navigate("/categories/regularSchemes")}
          />
          &nbsp;&nbsp;&nbsp;
          <div className="head_specialOffers">
            {" "}
            Schemes By Dsicount <br />
            <div className="specialOffers_navbar_mobile">
              <Link
                to="/categories/schemesByDiscount/all"
                className="text_decoration_none cursor_pointer navLink"
                style={{ margin: "5px 10px" }}
              >
                <p
                  className={
                    ("font_14",
                    location.pathname === "/categories/schemesByDiscount/all" &&
                      "activeClass")
                  }
                >
                  ALL
                </p>
              </Link>
              <Link
                to="/categories/schemesByDiscount/50-100"
                className="text_decoration_none cursor_pointer navLink"
                style={{ margin: "5px 10px" }}
              >
                <p
                  className={
                    ("font_14",
                    location.pathname ===
                      "/categories/schemesByDiscount/50-100" && "activeClass")
                  }
                >
                  {">"}50% OFF
                </p>
              </Link>

              <Link
                to="/categories/schemesByDiscount/10-50"
                className="text_decoration_none cursor_pointer navLink"
                style={{ margin: "5px 10px" }}
              >
                <p
                  className={
                    ("font_14",
                    location.pathname ===
                      "/categories/schemesByDiscount/10-50" && "activeClass")
                  }
                >
                  10-50% OFF
                </p>
              </Link>

              <Link
                to="/categories/schemesByDiscount/0-10"
                className="text_decoration_none cursor_pointer navLink"
                style={{ margin: "5px 10px" }}
              >
                <p
                  className={
                    ("font_14",
                    location.pathname ===
                      "/categories/schemesByDiscount/0-10" && "activeClass")
                  }
                >
                  {"<"} 10% OFF
                </p>
              </Link>
            </div>
          </div>
          <div className="specialOffers_navbar">
            <Link
              to="/categories/schemesByDiscount/all"
              className="text_decoration_none cursor_pointer navLink"
            >
              <p
                className={
                  ("font_14",
                  location.pathname === "/categories/schemesByDiscount/all" &&
                    "activeClass")
                }
              >
                ALL
              </p>
            </Link>
            <Link
              to="/categories/schemesByDiscount/50-100"
              className="text_decoration_none cursor_pointer navLink"
            >
              <p
                className={
                  ("font_14",
                  location.pathname ===
                    "/categories/schemesByDiscount/50-100" && "activeClass")
                }
              >
                {">"}50% OFF
              </p>
            </Link>

            <Link
              to="/categories/schemesByDiscount/10-50"
              className="text_decoration_none cursor_pointer navLink"
            >
              <p
                className={
                  ("font_14",
                  location.pathname === "/categories/schemesByDiscount/10-50" &&
                    "activeClass")
                }
              >
                10-50% OFF
              </p>
            </Link>

            <Link
              to="/categories/schemesByDiscount/0-10"
              className="text_decoration_none cursor_pointer navLink"
            >
              <p
                className={
                  ("font_14",
                  location.pathname === "/categories/schemesByDiscount/0-10" &&
                    "activeClass")
                }
              >
                {"<"} 10% OFF
              </p>
            </Link>
          </div>
        </Container>

        {allProductList && allProductList?.medicinesResponsesList?.length > 0 && (
          <div id="scrollableDiv" className="productList" style={{paddingTop: '0rem'}}>
            <InfiniteScroll
              dataLength={dataLength}
              next={fetchMoreData}
              hasMore={hasMore}
              scrollableTarget="scrollableDiv"
              scrollThreshold="90%"
              className="infiniteScroll"
              loader={
                <Spinner
                  animation="border"
                  className="color_secondary spinner"
                  size="lg"
                />
              }
            >
              {allProductList &&
                allProductList.medicinesResponsesList.map((med, index) => (
                  <ProductCard2
                    position={index}
                    screen={"regular_scheme_screen"}
                    key={index}
                    medData={med}
                  />
                ))}
            </InfiniteScroll>
          </div>
        )}

        {homeShimmer && (
          <Fragment>
            <div className="padding_5">
              <ProductCard2 shimmer={homeShimmer} />
            </div>
            <div className="padding_5">
              <ProductCard2 shimmer={homeShimmer} />
            </div>
            <div className="padding_5">
              <ProductCard2 shimmer={homeShimmer} />
            </div>
            <div className="padding_5">
              <ProductCard2 shimmer={homeShimmer} />
            </div>
            <div className="padding_5">
              <ProductCard2 shimmer={homeShimmer} />
            </div>
          </Fragment>
        )}
        {!homeShimmer &&
          allProductList &&
          allProductList.medicinesResponsesList.length === 0 && (
            <div
              id="scrollableDiv"
              className="productList "
              style={{ paddingTop: "50px" }}
            >
              <div className="no_data_parent">
                <img src={NoData} alt="No Data" />
                <br /> <br />
                <p className="font_ubuntu font_16 font_weight_md">
                  No Products Found !
                </p>
              </div>
            </div>
          )}
      </Container>
    </Fragment>
  );
};

export default React.memo(SchemesByDiscount);
